import * as React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography,
  TextField, Radio, RadioGroup, FormControlLabel, FormControl, Box,
  useMediaQuery, Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker
} from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { scheduleCall, sentfriendrequest } from '../../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';

export default function ScheduleCallDialog({
  open,
  onClose,
  userData,
  CallrequestId
}: {
  open: boolean;
  onClose: () => void;
  userData: any;
  CallrequestId: string;
}) {
  const theme = useTheme();
  console.log(userData, "userDatauserDatauserData");
  const {
    state: { user },
  } = React.useContext(AuthContext);
  const userDatas = user as AuthUser;
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [meetingType, setMeetingType] = React.useState<'Online' | 'In-person'>('Online');
  const [date, setDate] = React.useState<Dayjs | null>(null);
  const [startTime, setStartTime] = React.useState<Dayjs | null>(null);
  const [endTime, setEndTime] = React.useState<Dayjs | null>(null);
  const [title, setTitle] = React.useState<string>('');
  const [description, setDescription] = React.useState<string>('');
  const [meetingLink, setMeetingLink] = React.useState<string>('');

  const submit = () => {
    const data: any = {
      "Meeting_Title__c": title,
      "Meeting_Description__c": description,
      "MeetingRequestedBy__c": userDatas?.applicantId,
      "Meet_Date__c": date ? date.format('YYYY-MM-DD') : '',
      "Meet_Start_Time__c": startTime ? startTime.format('HH:mm') : '',
      "Meet_End_Time__c": endTime ? endTime.format('HH:mm') : '',
      "Meeting_Mode__c": meetingType,
      "Meeting_Link__c": meetingLink,
      "RecordTypeId": CallrequestId,
      "Meeting_Request_Sent__c": true,
      "Mentor__c": userData?.isMentor ? userData?.contactDetails?.id : userDatas?.applicantId,
      "Mentee__c": userData?.isMentee ? userData?.contactDetails?.id : userDatas?.applicantId,
    };
    console.log(data, "datadatadatadatadatadata"); // Replace with actual API call
    scheduleCall(data).then((res) => {
      if (res?.success) {
        enqueueSnackbar({
          message: 'Schedule a call successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        onClose();
      }
      else {
        enqueueSnackbar({
          message: 'Something went wrong',
          variant: 'error',
          autoHideDuration: 1000,
        });
      }
    })
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={fullScreen} style={{ fontSize: "14px" }}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} style={{ fontSize: "14px", padding: "10px 24px 0px 24px" }}>
        <Typography variant="subtitle1" fontWeight={500}>
          Schedule a Call with {userData?.contactDetails?.name}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <hr style={{ margin: "8px 23px" }} />

      <DialogContent style={{ fontSize: "14px" }}>
        <Typography fontWeight={"500"}>Title</Typography>
        <TextField
          fullWidth
          required
          style={{ fontSize: "14px" }}
          placeholder="Enter title"
          variant="outlined"
          sx={{ mt: 1, mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 1 } }}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Typography fontWeight={"500"} mt={1}>Add Description</Typography>
        <TextField
          fullWidth
          multiline
          minRows={3}
          placeholder="Add Description (optional)"
          variant="outlined"
          sx={{ mb: 3, mt: 1 }}
          style={{ fontSize: "14px" }}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }} style={{ fontSize: "14px" }}>
          Choose a preferred slot*
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box display="flex" flexDirection="column" gap={2} mb={3} style={{ fontSize: "14px" }}>
            <DatePicker
              label="Choose date"
              value={date}
              onChange={setDate}
              disablePast
              slotProps={{
                textField: { fullWidth: true, variant: 'outlined' }
              }}
            />
            <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} style={{ fontSize: "14px" }}>
              <TimePicker
                label="Start time"
                value={startTime}
                onChange={setStartTime}
                slotProps={{ textField: { fullWidth: true, variant: 'outlined' } }}
              />
              <TimePicker
                label="End time"
                value={endTime}
                onChange={setEndTime}
                slotProps={{ textField: { fullWidth: true, variant: 'outlined' } }}
              />
            </Box>
          </Box>
        </LocalizationProvider>

        <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }} style={{ fontSize: "14px" }}>
          How would you like to meet?*
        </Typography>
        <FormControl>
          <RadioGroup
            row
            value={meetingType}
            onChange={e => setMeetingType(e.target.value as 'Online' | 'In-person')}
          >
            <FormControlLabel value="Online" control={<Radio />} label="Online" />
            <FormControlLabel value="In-person" control={<Radio />} label="In-person" />
          </RadioGroup>
        </FormControl>

        <TextField
          fullWidth
          placeholder={
            meetingType === 'Online' ? 'Enter meet link (optional)' : 'Enter address'
          }
          variant="outlined"
          sx={{ mt: 2 }}
          value={meetingLink}
          onChange={(e) => setMeetingLink(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }} style={{ fontSize: "14px" }}>
        {/* <Button variant="text" sx={{ color: '#2E5DB0', textTransform: 'none' }}>
          Check Availability
        </Button> */}
        <Box flexGrow={1} />
        <Button onClick={onClose} variant="contained" color='secondary'>Cancel</Button>
        <Button onClick={submit} variant="contained" color="primary" >Send Request</Button>
      </DialogActions>
    </Dialog>
  );
}
